// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"37bfe566","979":"ceb199e7"}[chunkId] + ".css";
};